/**
 * Constants for modal functionality
 */

export const FOCUSABLE_SELECTORS = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

export const CLOSE_BUTTON_SELECTORS = [
    '.modal-header .btn-close',           // Bootstrap 5 header close button (X)
    '.modal-header [data-bs-dismiss="modal"]', // Any header dismiss button
    '.btn-close',                         // Any close button
    '[data-bs-dismiss="modal"]'          // Any dismiss button (footer)
];

export const BOOTSTRAP_EVENTS = {
    SHOW: 'show.bs.modal',
    SHOWN: 'shown.bs.modal',
    HIDE: 'hide.bs.modal',
    HIDDEN: 'hidden.bs.modal'
} as const;

export const EXCLUDED_ELEMENT_TAGS = ['script'];
export const EXCLUDED_ELEMENT_CLASSES = ['modal-backdrop'];